import createRouter from '~/plugins/router/router';

// > Router global instance
const routerInstance = createRouter();

export default routerInstance;
